<template>
    <div :class="'bizcomp-acct-security bizcomp ' + className">
        <div>
            <div class="acct-security-head-contain">
                <img src="../../assets/img/account-security.png" alt="" />
                <div>您的账户安全等级</div>
                <div class="acct-security-level-text">
                    {{ securityLevelC[securityLevel] }}
                </div>
                <img src="../../assets/img/security-level.png" alt="" />
                <img
                    src="../../assets/img/inverted-triangle.png"
                    alt=""
                    :class="
                        'point-triangle-img1 ' +
                        (securityLevel == 2
                            ? 'point-triangle-img2 '
                            : securityLevel == 3
                            ? 'point-triangle-img3'
                            : '')
                    "
                />
            </div>
            <div class="acct-security-content">
                <el-row class="el-row-common background-f9f9f9">
                    <el-col class="flex-align-center" :span="8">
                        <img v-if="isbind" src="../../assets/img/finish-icon.png" alt="" />
                        <img v-else src="../../assets/img/warn-yellow.svg" alt="" />
                        <span class="padding-left-14">密码</span>
                    </el-col>
                    <el-col :span="16">
                        <div class="flex-space-between">
                            <div></div>
                            <div>
                                <span
                                    v-if="
                                        $cache.getCompanyInfoParam('24111501') != '1' &&
                                        $util.getConfig().hideFunc
                                    "
                                    class="color-e60012 cursor-pointer"
                                    v-on:click="changeLPwd"
                                >
                                    修改登录密码
                                </span>
                                <span
                                    v-if="
                                        $cache.getCompanyInfoParam('24111501') != '1' &&
                                        $util.getConfig().hideFunc
                                    "
                                    class="margin-5"
                                >
                                    /
                                </span>
                                <span class="color-e60012 cursor-pointer" v-on:click="changeTPwd">
                                    修改交易密码
                                </span>
                                <span v-if="$util.getConfig().hideFunc" class="margin-5">/</span>
                                <span
                                    v-if="$util.getConfig().hideFunc"
                                    class="color-e60012 cursor-pointer"
                                    v-on:click="resetTPwd"
                                >
                                    忘记交易密码
                                </span>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="el-row-common">
                    <el-col class="flex-align-center" :span="8">
                        <img v-if="info.mobileno" src="../../assets/img/finish-icon.png" alt="" />
                        <img v-else src="../../assets/img/warn-yellow.svg" alt="" />
                        <span class="padding-left-14">手机号码</span>
                    </el-col>
                    <el-col :span="16">
                        <div class="flex-space-between">
                            <div>{{ info.mobileno || "未设置" }}</div>
                            <div>
                                <span class="color-e60012 cursor-pointer" v-on:click="modifyMobile">
                                    {{ info.mobileno ? "修改" : "增加" }}
                                </span>
                                <template
                                    v-if="
                                        $cache.getCompanyInfoParam('10114004') &&
                                        $cache.getCompanyInfoParam('10114004') == '1'
                                    "
                                >
                                    <span v-if="info.mobilebindflag !== '1'" class="margin-5">
                                        /
                                    </span>
                                    <el-tooltip
                                        v-if="info.mobilebindflag !== '1'"
                                        content="手机号将允许登录"
                                    >
                                        <span
                                            class="color-e60012 cursor-pointer"
                                            v-on:click="bindMobile"
                                        >
                                            绑定
                                        </span>
                                    </el-tooltip>
                                    <!-- <el-tooltip v-else content="手机号将不允许登录">
                                        <span
                                            class="color-e60012 cursor-pointer"
                                            v-on:click="unbindMobile"
                                        >
                                            解绑
                                        </span>
                                    </el-tooltip> -->
                                </template>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="el-row-common background-f9f9f9">
                    <el-col class="flex-align-center" :span="8">
                        <img v-if="info.email" src="../../assets/img/finish-icon.png" alt="" />
                        <img v-else src="../../assets/img/warn-yellow.svg" alt="" />
                        <span class="padding-left-14">电子邮箱</span>
                    </el-col>
                    <el-col :span="16">
                        <div class="flex-space-between">
                            <div>{{ info.email }}</div>
                            <div class="color-e60012 cursor-pointer" v-on:click="modifyEmail">
                                修改
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <!-- <el-row class="el-row-common">
                    <el-col class="flex-align-center" :span="8">
                        <img src="../../assets/img/no-finish-icon.png" alt="" />
                        <span class="padding-left-14"> 交易通知和短信</span>
                    </el-col>
                    <el-col :span="16">
                        <div class="flex-space-between">
                            <div>
                                系统免费帮您开通短信通知服务，资金变动第一时间通知
                            </div>
                            <div class="color-e60012">更换手机号码</div>
                        </div>
                    </el-col>
                </el-row> -->
                <el-row class="el-row-common background-f9f9f9">
                    <el-col class="flex-align-center" :span="8">
                        <img v-if="info.remark" src="../../assets/img/finish-icon.png" alt="" />
                        <img v-else src="../../assets/img/warn-yellow.svg" alt="" />
                        <span class="padding-left-14">预留信息</span>
                    </el-col>
                    <el-col :span="16">
                        <div class="flex-space-between">
                            <div>{{ info.remark ? info.remark : "未设置" }}</div>
                            <div class="color-e60012 cursor-pointer" v-on:click="modifyRemark">
                                修改
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="basic-info-contain">
            <div class="basic-info-head">
                <div class="basic-info-bar"></div>
                <div class="basic-info-title">账户安全相关信息</div>
            </div>
            <div class="acct-security-content" style="margin-top: 0">
                <el-row class="el-row-common">
                    <el-col class="flex-align-center" :span="8">
                        <span>账户登录记录</span>
                    </el-col>
                    <el-col :span="16">
                        <div class="flex-space-between">
                            <div />
                            <div
                                class="color-e60012 cursor-pointer"
                                v-on:click="$router.push({ name: 'acctinfologin' })"
                            >
                                查询
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row v-if="$const.pwdmodifySearch" class="el-row-common">
                    <el-col class="flex-align-center" :span="8">
                        <span>密码修改记录</span>
                    </el-col>
                    <el-col :span="16">
                        <div class="flex-space-between">
                            <div />
                            <div
                                class="color-e60012 cursor-pointer"
                                v-on:click="$router.push({ name: 'acctinfopwdmodify' })"
                            >
                                查询
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <!-- 弹窗 -->
        <check-mobile
            :show-mobile-comp="showMobileComp"
            v-on:dialog-close="dialogCloseFn"
        ></check-mobile>
        <change-emial
            :show-email-comp="showEmailComp"
            v-on:dialog-close="dialogCloseFn"
        ></change-emial>
        <smsValid
            sms-title="绑定手机号码"
            :mobileno="info.mobileno"
            :en-mobileno="info.en_mobileno"
            :dialog-visible="bindPhoneVisible"
            sms-type="3"
            :biz-type="$const.IMG_BIZTYPE.BIND_PHONE"
            :close-with-reset="false"
            v-on:sms-comfirm="bindPhoneConfirm"
            v-on:close="bindPhoneClose"
        />
        <el-dialog
            v-if="remarkShow"
            :title="typeLabel + '预留信息'"
            :visible.sync="remarkShow"
            class="prop info-tips"
            width="650px"
            :before-close="closeDialog"
        >
            <div class="investor-tips">
                <div v-if="!isResPage">
                    <el-form
                        ref="ruleForm"
                        class="two-cols-form mt-20px color-999"
                        :model="ruleForm"
                        :rules="rules"
                        label-width="120px"
                        size="small"
                    >
                        <el-form-item label="当前预留信息：">
                            <div class="ml-15">
                                {{ info.remark ? info.remark : "未设置" }}
                            </div>
                        </el-form-item>
                        <el-form-item label="修改预留信息：" prop="remark" class="mt-20px">
                            <el-input
                                v-model="ruleForm.remark"
                                class="w-80"
                                type="text"
                                :maxlength="16"
                                placeholder="请输入16个字符以内的信息"
                            />
                        </el-form-item>
                        <el-form-item
                            v-if="isPwdCheck"
                            label="交易密码："
                            prop="tradepwd"
                            class="mt-20px"
                        >
                            <el-input
                                v-model="ruleForm.tradepwd"
                                class="w-80"
                                type="password"
                                show-password
                                :maxlength="16"
                                placeholder="请输入交易密码"
                                auto-complete="new-password"
                            />
                            <span
                                class="redemp-btn mt-4px"
                                v-on:click.prevent="$router.push({ name: 'tradepwd' })"
                            >
                                <span class="like-a">忘记密码？</span>
                            </span>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer mt-20px">
                        <div class="warn-tip-contain">
                            <div class="warn-tip-text">
                                温馨提示：请记住您设置的预留信息，该信息将在您登录网上交易系统置顶栏显示，若该页面未能正确显示您的预留信息，请及时联系客服热线{{
                                    $cache.getCompanyInfoParam("10101009")
                                }}进行确认。
                            </div>
                        </div>
                        <div class="btn-box">
                            <el-button type="primary" class="add-btn" v-on:click="addRemark">
                                确认
                            </el-button>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="result-contain">
                        <div>
                            <img src="../../assets/img/success.png" alt="" />
                        </div>
                        <div class="result-text">预留信息{{ typeLabel }}成功!</div>
                    </div>
                    <div class="btn-box">
                        <el-button type="primary" class="add-btn" v-on:click="closeDialog">
                            确认
                        </el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import checkMobile from "./checkMobileDc.vue";
import smsValid from "@/components/form/smsValid";
import changeEmial from "./changeEmialDc.vue";
import userApi from "@/api/user";

export default {
    name: "AcctSecurityDc",
    components: {
        checkMobile,
        smsValid,
        changeEmial
    },
    mixins: [mixin],
    data() {
        return {
            // 您的账户安全等级
            securityLevel: 0,
            securityLevelC: ["低", "低", "中", "高"],
            // 基本信息
            isbind: false,
            showMobileComp: false,
            bindPhoneVisible: false,
            showEmailComp: false,
            info: {},
            // 基本信息-预留信息
            remarkShow: false,
            isPwdCheck: false,
            isResPage: false,
            typeLabel: "修改",
            ruleForm: {
                tradepwd: "",
                remark: ""
            },
            rules: {
                remark: [{ required: true, message: "请输入预留信息", trigger: "change" }],
                tradepwd: [{ required: true, message: "请输入交易密码", trigger: "change" }]
            }
        };
    },
    computed: {
        isPhoneLogin() {
            return this.$cache.getUserOtherInfo().accttype === "8";
        }
    },
    watch: {
        "$store.state.user.refreshTrigger"() {
            this.modifyRemark();
        }
    },
    created() {
        this.info = this.$cache.getUser();
        this.isbind = sessionStorage.getItem("binded");
        if (this.isbind) {
            this.securityLevel += 1;
        }
        if (this.info.mobileno) {
            this.securityLevel += 1;
        }
        if (this.info.email) {
            this.securityLevel += 1;
        }
    },
    mounted() {
        if (this.$route.params && this.$route.params.next === "remark") {
            this.modifyRemark();
        }
        if (this.$route.params && this.$route.params.next === "mobile") {
            this.modifyMobile();
        }
    },
    methods: {
        updateInfo() {
            this.$cache.refreshUser(() => {
                this.info = this.$cache.getUser();
                this.$store.dispatch("setInfo", this.info);
            });
        },
        // 密码
        changeLPwd() {
            this.$router.push({ name: "changelpwd" });
        },
        changeTPwd() {
            this.$router.push({ name: "changetpwd" });
        },
        resetTPwd() {
            // 获取已开户无线上卡/未绑定银行卡的客户
            this.$util.getBusinesBankInfo({ businessflag: "9" }).then((res) => {
                const bankLists = res.filter((item) => {
                    return (
                        item.authenticateflag === "1" && // 已鉴权才能购买
                        item.ischannelstop === "1" // 屏蔽停用的卡（0-停用，1-正常）
                    );
                });

                if (bankLists.length > 0) {
                    this.$router.push({ name: "tradepwd" });
                } else {
                    this.$message.error(
                        "为保障您的账户安全，重置交易密码需存在开通线上支付的银行卡"
                    );
                }
            });
        },
        // 手机号码
        modifyMobile() {
            this.showMobileComp = true;
        },
        unbindMobile() {
            this.$confirm("是否进行手机号解绑！解绑后无法用该手机号登录", "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                type: ""
            }).then(() => {
                userApi.unbindMobile({ bindtype: "8" }, true).then(() => {
                    this.$message.success("解绑成功");
                    this.updateInfo();
                });
            });
        },
        bindMobile() {
            this.bindPhoneVisible = true;
        },
        bindPhoneConfirm() {
            userApi
                .bindMobile(
                    {
                        bindtype: "8",
                        en_certificateno: this.info.en_certificateno,
                        certificatetype: this.info.certificatetype,
                        en_mobileno: this.info.en_mobileno
                    },
                    true
                )
                .then(() => {
                    this.$message.success("绑定成功");
                    this.updateInfo();
                });
        },
        bindPhoneClose() {
            this.bindPhoneVisible = false;
        },
        // 电子邮箱
        modifyEmail() {
            this.showEmailComp = true;
        },
        dialogCloseFn(value) {
            this.showMobileComp = value;
            this.showEmailComp = value;
            this.info = this.$cache.getUser();
        },
        // 预留信息
        modifyRemark() {
            this.ruleForm.remark = "";
            this.ruleForm.tradepwd = "";
            this.typeLabel = this.info.remark && this.info.remark !== " " ? "修改" : "新增";
            this.remarkShow = true;
        },
        closeDialog() {
            this.remarkShow = false;
            this.isResPage = false;
        },
        addRemark() {
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    const res = await userApi.updRemark({ remark: this.ruleForm.remark });
                    if (res.code == "0") {
                        this.isResPage = true;
                        this.updateInfo();
                    }
                } else {
                    return false;
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-acct-security {
    position: relative;
    .acct-security-head-contain {
        display: flex;
        align-items: center;
        height: 110px;
        border-radius: 6px;
        background: linear-gradient(180deg, #ffefe5 0%, #ffe6d5 100%);
        font-weight: normal;
        font-size: 16px;
        .acct-security-level-text {
            margin: 0 16px;
            font-size: 20px;
            font-weight: 500;
        }
        .point-triangle-img1 {
            position: absolute;
            left: 315px;
            top: 35px;
        }
        .point-triangle-img2 {
            position: absolute;
            left: 405px;
            top: 35px;
        }
        .point-triangle-img3 {
            position: absolute;
            left: 495px;
            top: 35px;
        }
    }
    .acct-security-content {
        background: #ffffff;
        box-sizing: border-box;
        border: 1px solid #f1f1f1;
        margin-top: 30px;
        .el-row-common {
            height: 50px;
            line-height: 50px;
            padding: 0 16px;
        }
    }
    .flex-space-between {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .flex-align-center {
        display: flex;
        align-items: center;
    }
    .color-e60012 {
        color: var(--color-primary);
    }
    .padding-left-14 {
        padding-left: 14px;
    }
    .background-f9f9f9 {
        background-color: #f9f9f9;
    }
    .margin-5 {
        margin: 0 5px;
    }
    .cursor-pointer {
        cursor: pointer;
    }
}
::v-deep .el-dialog__header {
    padding: 10px !important;
}
::v-deep .el-dialog__headerbtn {
    top: 0 !important;
}
::v-deep .el-form-item__label {
    color: #999999 !important;
}
.mt-20px {
    margin-top: 20px;
}
.mt-4px {
    margin-top: 4px;
}
.w-85 {
    width: 85%;
}
.ml-15 {
    margin-left: 15px;
}
.btn-box {
    text-align: center;
    margin-top: 10px;

    cursor: pointer;
    .add-btn {
        width: 180px;
        height: 42px;
        border-radius: 2px;
        background: var(--color-primary);
        border: 1px solid var(--color-primary);
        color: #ffffff;
    }
}
.warn-tip-contain {
    line-height: 20px;
    padding: 10px 20px 10px;
    .warn-tip-text {
        text-indent: 2em;
        margin-top: 6px;
        color: #999999;
    }
}
.color-999 {
    color: #999999;
}
.redemp-btn {
    margin-left: 10px;
}
.result-contain {
    background-color: rgb(250, 250, 250);
    width: 100%;
    text-align: center;
    padding-top: 50px;
    padding-bottom: 30px;
    margin-top: 30px;
}
.result-text {
    font-weight: bold;
    margin-top: 20px;
    font-size: 18px;
}

.basic-info-contain {
    margin-top: 20px;
    border: 1px solid #f1f1f1;
    box-sizing: border-box;
    .head-contain {
        display: flex;
        justify-content: space-between;
        padding-right: 16px;
        .basic-info {
            background: #f9f9f9;
            display: flex;
            align-items: center;
        }
    }
    .basic-info-head {
        height: 60px;
        background: #f9f9f9;
        display: flex;
        align-items: center;
        padding-left: 16px;

        .basic-info-bar {
            width: 4.68px;
            height: 16px;
            background: var(--color-primary);
        }
        .basic-info-title {
            margin-left: 6px;
            font-size: 18px;
            font-weight: bold;
            color: #333333;
        }
    }
    .certificate-contain-main {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .certificate-contain {
        display: flex;
        align-items: center;
        .certificate-warn-expire {
            display: flex;
            align-items: center;
            margin-left: 20px;
            .certificate-warn-expire-text {
                margin-left: 6px;
                color: var(--color-primary);
            }
        }
    }
    .el-row-common {
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #f1f1f1;
        display: flex;
        align-items: center;
        color: #333333;
    }
    .save-money-to-purchase,
    .risk-tolerance-contain {
        border-bottom: 1px solid #f1f1f1;
        display: flex;
        align-items: center;
        color: #333333;
        height: 80px;
        .save-money-to-purchase-text {
            margin-left: 10px;
            color: #999999;
        }
        .save-money-to-purchase-protocol {
            color: #1890ff;
            cursor: pointer;
        }
    }
    .el-col-border {
        font-weight: bold;
        border-right: 1px solid #f1f1f1;
    }
    .save-money-to-purchase-border,
    .risk-tolerance-border {
        height: 80px;
        line-height: 80px;
        font-weight: bold;
        border-right: 1px solid #f1f1f1;
    }
    .el-col-padding-left {
        padding: 0 16px;
    }
}
</style>
